import styled from 'styled-components'
import { theme } from '../../../styles/theme'

interface IContainer {
  isChecked: boolean;
}

export const Container = styled.button<IContainer>`
  width: 18px;
  height: 18px;

  border: 2px solid ${theme.colors.black};
  background: ${({ isChecked }) => (isChecked ? theme.colors.green : 'transparent')};
`
